import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';
import classNames from 'classnames';

class ClientTaskList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false
    };

    this.completeTask = this.completeTask.bind(this);
  }

  completeTask(id, e) {
    const payload = this.props.tasks.find((task) => {
      return task._id == id;
    });

    payload.completed = e.target.checked;

    this.props.sendSocketEmit(payload, 'client-task-complete');
  }

  render() {
    const clientHasTasks = this.props.client.tasks;

    if (!clientHasTasks.length) return (<div>There have been no tasks created for this client.</div>);

    return (
      <div>
        <hr className="dotted short" />
        <ul className="widget-todo-list">
          {this.props.tasks.map((task, idx) => {
            const hasDueDate = moment(task.due_date).isValid();
            const formattedDueDate = moment(task.due_date).format('YYYY.MM.DD');

            if (task.completed && !this.props.showCompleted) {
              return;
            }

            return (
              <li key={idx} className={`animated fadeIn ${classNames({'task-completed': task.completed })}`}>
                <div className="checkbox-custom checkbox-default">
                  <input checked={task.completed} onChange={ this.completeTask.bind(this, task._id) } type="checkbox" id={`todo-${idx}`} className="todo-check"/>
                  <label className="todo-label">
                    <span className="task-text">
                      { task.text }
                    </span>
                  </label>
                </div>
                <div className="todo-actions">
                  {(() => {
                    if (hasDueDate) {
                      return (<span className="task-due-date">{this.state.checked} { formattedDueDate }</span>);
                    }
                  })()}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

ClientTaskList.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ client }) => ({ client });

export default connect(mapStateToProps, Actions)(ClientTaskList);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-task-list.js